package com.fireavert.yardi.common_data.data_models


enum class YardiResidentStatusEnum(val value: String) {
    ALL("All"),
    CURRENT("Current"),
    PAST("Past"),
    FUTURE("Future"),
    EVICTION("Eviction"),
    NOTICE("Notice"),
    DENIED("Denied"),     // For v25+ support
    CANCELLED("Cancelled"), // For v25+ support
    APPLICANT("Applicant"), // For v25+ support
    APPROVED("Approved");  // For v23+ support

    override fun toString(): String {
        return value
    }

    companion object {
        fun fromString(value: String): YardiResidentStatusEnum? {
            return entries.find { it.value.equals(value, ignoreCase = true) }
        }
    }
}